import { Box, Typography, Avatar } from '@mui/material';
import { SupportAgent } from '@mui/icons-material';
import { useTranslation } from '../../../kit/useTranslation';

export default function SupportHeader() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        pt: 3,
        pb: 4,
        px: 2,
        textAlign: 'center',
      }}
    >
      <Avatar
        sx={{
          width: 64,
          height: 64,
          bgcolor: 'rgba(255, 255, 255, 0.2)',
          mx: 'auto',
          mb: 2,
        }}
      >
        <SupportAgent sx={{ fontSize: 36 }} />
      </Avatar>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        {t('support.howCanWeHelp')}
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.9 }}>
        {t('support.quickAnswers')}
      </Typography>
    </Box>
  );
}
